import React, { ReactNode, useMemo, useState } from 'react';
import { useReactive } from '@wix/bex-utils/react';
import {
  PageContextProvider,
  useWixPatternsContainer,
} from '@wix/bex-core/react';
import { PageState, SidePanelWidth } from '@wix/bex-core';

export interface PageWrapperBaseProps {
  pageState?: PageState;
  children?: ReactNode;
}

export function PageWrapperBase(props: PageWrapperBaseProps) {
  const { pageState, children } = props;

  const [state] = useState(() => pageState ?? new PageState());
  const { modalsContainerRef, stackingRootRef, _sidePanelOpen } = state;
  const sidePanelOpen = useReactive(_sidePanelOpen);
  const { environment } = useWixPatternsContainer();

  const pageAndModalsRootStyle = useMemo(
    () => ({
      position: 'relative' as const,
      width: sidePanelOpen ? `calc(100% - ${SidePanelWidth}px)` : '100%',
      height: '100%',
      transition: 'width 0.4s ease 0s',
    }),
    [sidePanelOpen],
  );

  const pageContainerStyle = useMemo(
    () => ({
      position: 'relative' as const,
      width: '100%',
      height: '100%',
      zIndex: 1,
    }),
    [],
  );

  const modalsContainerStyle = useMemo(
    () => ({
      position: 'absolute' as const,
      zIndex: 1,
    }),
    [],
  );

  return (
    <PageContextProvider value={state}>
      <div
        data-cairo
        data-hook="cairo-root-stacking"
        style={pageAndModalsRootStyle}
        ref={(el) => {
          stackingRootRef.current = el;
        }}
        lang={environment.language}
      >
        <div style={pageContainerStyle}>{children}</div>
        <div
          ref={(el) => {
            modalsContainerRef.current = el;
          }}
          style={modalsContainerStyle}
        />
      </div>
    </PageContextProvider>
  );
}
